/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LoanDefinitionType {
    MANAGEMENT_LOAN = 'MANAGEMENT_LOAN',
    DEFERRED_PAYMENT = 'DEFERRED_PAYMENT',
}
